import {
  Box,
  Button,
  InputBase,
  makeStyles,
  Paper,
  Typography,
  useTheme,
} from '@material-ui/core';
import { orange } from '@material-ui/core/colors';
import GetAppIcon from '@material-ui/icons/GetApp';
import React from 'react';

const DocBarStyle = makeStyles((theme) => ({
  outerBox: {
    alignContent: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  downloadButton: {
    background:
      'linear-gradient(25deg, ' +
      theme.palette.steicolors.lightside +
      ' 0%, ' +
      theme.palette.steicolors.darkside +
      ' 100%)',
    color: theme.palette.type === 'dark' ? '#e0e0e0' : '#4e4e4e',
    '&:hover': {
      color: orange[300],
    },
  },
  secText: {
    fontSize: 'x-small',
  },
  mainText: {
    fontSize: 'medium',
    marginRight: 16,
    cursor: 'pointer',
    '&:hover': {
      color: '#FFA840',
      cursor: 'pointer',
    },
  },
  mainTextInput: {
    cursor: 'pointer',
  },
}));

export function DocumentBar(props) {
  const classes = DocBarStyle();
  const theme = useTheme();

  let link = { ...props }.link;
  let filename = { ...props }.filename;
  let fileext = { ...props }.fileext;
  let preprocesstype = { ...props }.preprocess;

  if (fileext === null || fileext === undefined) {
    fileext = link.split('.').pop();
  } else {
    fileext = String(filename.split('.').pop());
  }

  if (filename === null || filename === undefined) {
    filename = link
      .split('/')
      .pop()
      .replace(/\.[^/.]+$/, '');
  } else {
    filename = String(filename.replace(/\.[^/.]+$/, ''));
  }

  const download = (dlink, dfilename) => {
    let element = document.createElement('a');

    dlink = preprocessDownloadLink(preprocesstype, dlink);

    element.setAttribute('href', dlink);
    element.setAttribute('download', dfilename);

    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };

  const InputButton = () => (
    <Button
      id="1"
      variant="contained"
      color="primary"
      startIcon={<GetAppIcon />}
      style={{
        marginTop: 0,
        marginBottom: 0,
        marginRight: theme.spacing(1),

        left: 0,
        minWidth: 88,
      }}
      className={classes.downloadButton}
      onClick={() => {
        download(link, filename + '.' + fileext);
      }}
    >
      Unduh
    </Button>
  );

  return (
    <Paper elevation={8}>
      <Box className={classes.outerBox} flexDirection="row">
        <InputButton />
        <Box
          flexDirection="column"
          padding={0}
          margin={0}
          style={{ display: 'inline-block' }}
          width="100%"
        >
          <InputBase
            readOnly={true}
            fullWidth
            className={classes.mainText}
            onClick={() => {
              window.open(link);
            }}
            inputProps={{
              className: classes.mainTextInput,
            }}
            value={filename}
          />
          <Typography color="textSecondary" className={classes.secText}>
            {fileext.toUpperCase()}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}

function preprocessDownloadLink(preprocesstype, link) {
  // If possible then process the download link into a viewable one or vice versa
  // More or less deprecated with the newest cloud storage URL scheme but...
  if (preprocesstype === 'cloudinary') {
    return link;
  } else {
    return link;
  }
}
